const BaseModel = require('../models/base');

let cache = new BaseModel.Collection();

module.exports = cache;
